import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import TelephonyReportList from '../../../components/reports/telephony/TelephonyReportList'
import UserLoginReport from '../../../components/reports/telephony/SelectedTelephoneyList/UserLoginReport'
import AgentPerformanceReport from '../../../components/reports/telephony/SelectedTelephoneyList/AgentPerformanceReport'
import ContactDetailReport from '../../../components/reports/telephony/SelectedTelephoneyList/ContactDetailReport'
import InboundCallDetailReport from '../../../components/reports/telephony/SelectedTelephoneyList/InboundCallDetailReport'
import BreakReport from '../../../components/reports/telephony/SelectedTelephoneyList/BreakReport'
import AbandonedCallsReport from '../../../components/reports/telephony/SelectedTelephoneyList/AbandonedCallsReport'
// report
import UserLoginReport1 from '../../../components/reports/telephony/SelectedTelephoneyList/UserLoginReport1'
import AgentPerformanceReport1 from '../../../components/reports/telephony/SelectedTelephoneyList/AgentPerformanceReport1'
import ContactDetailReport1 from '../../../components/reports/telephony/SelectedTelephoneyList/ContactDetailReport1'
import InboundCallDetailReport1 from '../../../components/reports/telephony/SelectedTelephoneyList/InboundCallDetailReport1'
import BreakReport1 from '../../../components/reports/telephony/SelectedTelephoneyList/BreakReport1'
import AbandonedCallsReport1 from '../../../components/reports/telephony/SelectedTelephoneyList/AbandonedCallsReport1'

const TelephonyRoute = () => {
    const tenant = localStorage.getItem('circleone-user')?.toLowerCase()
   const isMdIndia = tenant === 'mdindia' || tenant === 'stage' || tenant === 'victorinox' || tenant === 'cslfinance' || tenant === 'knabfinance' || tenant === 'mdindiadcinvoice'  || tenant === 'csquare' || tenant === 'payswiffibl' || tenant === 'payswiffstage'  || tenant === 'briezi' ;

    return (
        <Routes>

            <Route
                path='/reports-list'
                element={
                    <>
                        <TelephonyReportList />
                    </>
                }
            />

            <Route
                path='/phone-login'
                element={
                    isMdIndia ? <UserLoginReport /> : <UserLoginReport1 />
                }
            />
            <Route
                path='/inbound-login'
                element={
                    isMdIndia ? <AgentPerformanceReport /> : <AgentPerformanceReport1 />
                }
            />
            <Route
                path='/contactdetails-report'
                element={
                    isMdIndia ? <ContactDetailReport /> : <ContactDetailReport1 />
                }
            />
            <Route
                path='/campign-wise-report'
                element={
                    isMdIndia ? <InboundCallDetailReport /> : <InboundCallDetailReport1 />
                }
            />
            <Route
                path='/phone-break-report'
                element={
                    isMdIndia ? <BreakReport /> : <BreakReport1 />
                }
            />
            <Route
                path='/abandoned-report'
                element={
                    isMdIndia ? <AbandonedCallsReport /> : <AbandonedCallsReport1 />
                }
            />

       

            <Route index element={<Navigate to='/telephony/reports-list' />} />

        </Routes >
    )
}

export default TelephonyRoute
